import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Navigation */}
      <nav className="nav">
        <div className="container">
          <div className="nav-content">
            <div className="logo">madida</div>
            <a href="mailto:contact@madida.io" className="contact-link">Contact Us</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1 className="hero-title">
            Transform Your<br />
            Startup Vision<br />
            Into Reality
          </h1>
          <p className="hero-subtitle">
            We're not just investors — we're your strategic partners in building 
            the next generation of breakthrough companies. From seed to scale, we've got your back.
          </p>
          <a href="mailto:contact@madida.io" className="cta-button">
            Get in Touch
          </a>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2 className="section-title">What We Do</h2>
          
          <div className="services-grid">
            {/* Service 1 */}
            <div className="service-card">
              <div className="service-icon">💎</div>
              <h3 className="service-title">Angel Investment with Impact</h3>
              <p className="service-description">
                We back bold ideas and passionate founders. Our early-stage investments 
                fuel the next wave of innovation.
              </p>
            </div>

            {/* Service 2 */}
            <div className="service-card">
              <div className="service-icon">🎯</div>
              <h3 className="service-title">Strategic Startup Advisory</h3>
              <p className="service-description">
                From idea validation to product-market fit — we offer personalized 
                mentorship and business guidance every step of the way.
              </p>
            </div>

            {/* Service 3 */}
            <div className="service-card">
              <div className="service-icon">🤝</div>
              <h3 className="service-title">Founder-Centric Support</h3>
              <p className="service-description">
                We're more than advisors — we're partners. We help entrepreneurs navigate 
                challenges, avoid common pitfalls, and build with clarity.
              </p>
            </div>

            
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact">
        <div className="container">
          <div className="contact-content">
            <h2 className="contact-title">Let's Build Something Great Together</h2>
            <p className="contact-subtitle">
              Ready to take your startup to the next level? We'd love to hear from you.
            </p>
            <div className="contact-email">
              <a href="mailto:contact@madida.io" className="email-link">
                contact@madida.io
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="logo">madida</div>
            <p className="footer-text">© 2024 Madida. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;